export enum DateType {
    TODAY = 'TODAY',
    THISWEEK = 'THISWEEK',
    NEXTWEEK = 'NEXTWEEK',
    NOLIMIT = 'NOLIMIT',
}
